// extracted by mini-css-extract-plugin
export default {"root":"IconClose_root__2IUUi"};